module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZdZ5tK/tc-custom/9781488061530.jpg?1726519015569",
      "alt": "This image is the cover for the book Christmas Protection Detail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Christmas Protection Detail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A couple must keep an orphaned baby safe from child traffickers in this inspirational romantic suspense.")]), _c('br'), _c('br'), _vm._v("When a call from a friend in trouble leads Nick Delaney and Deputy Kaitlyn Lanz to a car crash that killed a single mother, they become the baby’s protectors. Now figuring out why someone is after the child is the only way to save her. But they must find answers soon . . . or this baby’s first Christmas might just be Nick’s and Kaitlyn’s last.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Reed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award winning, multipublished author Terri Reed writes heart-warming romance and heart-pounding suspense. Her books have appeared on Publisher's Weekly top ten, Nielsen's Bookscan top fifty, Amazon Bestseller and featured in USA Today.  You can visit her online at www.terrireed.com or email her at terrireed@sterling.net ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0